import { make } from 'vuex-pathify';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const initialState = {
  currentStepNumber:            0,
  length:                       3,
  minimumMonthlyIncome:         null,
  hasValidScrConsent:           null,
  hasWhatsappConsent:           null,
  hasPositiveCreditDataConsent: null,
  hasMainPhoneNumber:           false,
  submittingRegData:            false,
  reg1:                         {
    full_name:                         null,
    email:                             null,
    date_of_birth:                     null,
    cpf:                               null,
    main_phone:                        null,
    password:                          null,
    password_confirmation:             null,
    wants_electronic_promotions:       null,
    privacy_policy:                    null,
    privacy_policy_text:               null,
    whatsapp_consent:                  null,
    whatsapp_consent_text:             null,
    positive_credit_data_consent:      null,
    positive_credit_data_consent_text: null,
    recaptcha_token:                   null,
  },
  reg2: {
    mother_name:         null,
    gender:              null,
    educational_level:   null,
    nationality:         null,
    birth_region:        null,
    marital_status:      null,
    brazil_id_issuer:    null,
    brazil_id_number:    null,
    brazil_id_issued_on: null,
    brazil_id_region:    null,
    zipcode:             null,
    street_address:      null,
    street_number:       null,
    additional_info:     null,
    city:                null,
    state:               null,
    time_at_address:     null,
    residence_type:      null,
    home_phone:          '', // optional field
  },
  reg3: {
    income_source:         null,
    position:              null,
    employer:              null,
    time_at_job:           null,
    monthly_income:        null,
    income_payment_method: null,
    paydate_ordinal:       null,
    net_worth:             null,
    loan_purpose:          null,
    bank_name:             null,
    bank_branch:           null,
    bank_account_type:     null,
    caixa_account_type:    null,
    bank_account_number:   null,
  },
  ebs:                null,
  disabledFieldNames: [],
};

export default {
  namespaced: true,
  state:      initialState,
  getters:    {
    ...make.getters(initialState),
    ...getters,
  },
  mutations: {
    ...make.mutations(initialState),
    ...mutations,
  },
  actions: {
    ...make.actions(initialState),
    ...actions,
  },
};
